import React from 'react';


interface Props {
	title?: string;
	content?: string;
	forceShow?: boolean;
	className?: string;
}

export function DocFragment({title, content, forceShow, className}: Props) {
	return (content || forceShow) ? (
		<div className={className}>
			{title && <h3>{title}</h3>}
			<div className="doc-fragment"
				 dangerouslySetInnerHTML={{__html: content || ''}}/>
		</div>
	) : null;
}
